module.exports = __webpack_public_path__ + "img/client6.12b917ee.png";